// extracted by extract-css-chunks-webpack-plugin
module.exports = {"mobileWidth":"575.98px","tabletWidth":"767.98px","laptopWidth":"991.98px","desktopWidth":"1199.98px","retinaWidth":"1919.98px","mobileHeight":"599.98px"};